import React, { memo, useState, useEffect, useCallback } from 'react';
import { View } from 'react-native';

import { FormInput, DropDown, FormHelpers, I18n, Navigation } from '../components';

const address1Ref = React.createRef();
const address2Ref = React.createRef();
const cityRef = React.createRef();
const stateRef = React.createRef();
const countryRef = React.createRef();
const timeZoneRef = React.createRef();

const NameForm = memo((props) => {
  const employer = props.employer || {};
  const [address1, setAddress1] = useState(employer.location?.street1 || null);
  const [address2, setAddress2] = useState(employer.location?.street2 || null);
  const [city, setCity] = useState(employer.location?.city || null);
  const [state, setState] = useState(employer.location?.state || null);
  const [country, setCountry] = useState(employer.location?.country || null);
  const [timeZone, setTimeZone] = useState(employer.timeZone || null);

  useEffect(() => {
    const isValid = FormHelpers.validateFields([
      address1Ref.current,
      address2Ref.current,
      cityRef.current,
      stateRef.current,
      countryRef.current,
      timeZoneRef.current,
    ]);
    const location = {
      ...(props.employer?.location || {}),
      street1: address1,
      street2: address2,
      city: city,
      state: state,
      country: country,
      name: props.employer.name,
      address: `${address1} ${address2 ? address2 + ' ' : ''}${city} ${state} ${country}`,
    };

    props.onDataChange({ ...employer, location, timeZone }, isValid);
  }, [address1, address2, city, state, country, timeZone]);

  const openTimeZoneSelect = useCallback(() => {
    Navigation.showModal({
      screen: 'EventTimeZones',
      title: I18n.t('calendar.timeZone'),
      passProps: {
        setSelected: setTimeZone,
        selectedId: timeZone,
      },
    });
  }, [timeZone]);

  return (
    <View style={{ marginBottom: 20 }}>
      <FormInput
        ref={address1Ref}
        value={address1}
        label={'Address 1'}
        required={true}
        onChangeText={setAddress1}
        controlled={true}
        autoCorrect={false}
      />
      <FormInput
        ref={address2Ref}
        value={address2}
        label={'Address 2'}
        required={false}
        onChangeText={setAddress2}
        controlled={true}
        autoCorrect={false}
      />
      <FormInput
        ref={cityRef}
        value={city}
        label={'City'}
        required={true}
        onChangeText={setCity}
        controlled={true}
        autoCorrect={false}
      />
      <FormInput
        ref={stateRef}
        value={state}
        label={'State'}
        tipText="Ex: New York"
        required={true}
        onChangeText={setState}
        controlled={true}
        autoCorrect={false}
      />
      <FormInput
        ref={countryRef}
        value={country}
        label={'Country'}
        tipText="Ex: US"
        required={true}
        onChangeText={setCountry}
        controlled={true}
        autoCorrect={false}
      />
      <DropDown
        ref={timeZoneRef}
        label={I18n.t('calendar.timeZone')}
        value={timeZone}
        required={true}
        imageSource={require('../../../resources/icon-time.png')}
        onPress={openTimeZoneSelect}
      />
    </View>
  );
});

export default NameForm;
